import React from 'react';
import { PageHeader } from '../../components/Shared';
import ScheduleCalendar from '../../components/ScheduleCalendar';

const AdminSchedule = () => (
  <div className="p-4 sm:p-6 lg:p-8 space-y-6" data-testid="admin-schedule-page">
    <PageHeader
      title="Schedule"
      description="Plan shifts per engineer and per customer. Work-order start-by / finish-by windows surface automatically."
    />
    <ScheduleCalendar role="admin" />
  </div>
);

export default AdminSchedule;
